import '@babel/polyfill'
import 'url-search-params-polyfill';

import Vue from 'vue'
import App from './App.vue'
import Vuex from 'vuex'
import AOS from 'aos';
import 'aos/dist/aos.css';
// import router from "./router.js"

import VueI18n from 'vue-i18n'
import LangEn from './language/en_US'
import LangZhCN from './language/zh_CN'
import LangZhHK from './language/zh_HK'
import defined from './javascripts/defined.js'
import router from "./javascripts/router.js"
import comment from "./javascripts/comment.js"
import './style/style.scss'
import './style/bootstrap.min.css'
import './style/swiper.min.css'
import api from './javascripts/apiCall.js'
import VueGtag from "vue-gtag";
import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper)

// swiper.animate 给每张swiper加动画效果
import * as swiperAni from "../public/static/swiper.animate.min.js"
Vue.prototype.$swiperAnimateCache = swiperAni.swiperAnimateCache;
Vue.prototype.$swiperAnimate = swiperAni.swiperAnimate;
Vue.prototype.$clearSwiperAnimate = swiperAni.clearSwiperAnimate;

// Vue.config.productionTip = false
Vue.prototype.api = api
Vue.prototype.comment = comment


import VueMeta from 'vue-meta'

Vue.use(VueMeta)

import VModal from 'vue-js-modal'
Vue.use(VModal, {
  dialog: true,
  dynamic: true,
})
Vue.use(VueI18n)
Vue.use(Vuex)
const store = new Vuex.Store(defined)

const i18n = new VueI18n({
  locale: 'en_US',
  messages: {
    'en_US': LangEn,
    'zh_CN': LangZhCN,
    'zh_HK': LangZhHK
  }
})

var VUE_APP_GA_ID = process.env.VUE_APP_GA_ID
// Vue.use(VueAnalytics, {
//   id: VUE_APP_GA_ID,
//   router,
//   autoTracking: {
//     pageviewTemplate(route) {
//       return {
//         page: route.path,
//         title: route.meta.title,
//         location: window.location.href
//       }
//     }
//   }
// })
Vue.use(VueGtag, {
  config: { id: VUE_APP_GA_ID },
  pageTrackerTemplate(route) {
    return {
      page: route.path,
      title: route.meta.title,
      location: window.location.href
    }
  }
}, router);
var app = new Vue({
  router,
  i18n,
  store,
  created() {
    AOS.init()
  },
  render: h => h(App),
}).$mount('#app')


